import React from 'react';

import { Blocks as LayoutBlocks } from '../layout/Types.jsx';
import Utilities from './Utilities.jsx';

function withBlockRendering(WrappedComponent, contentBlocks, blockExtrasHandler) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            const config = this._getConfig(props);
            this.state = {
                hash: Utilities.Config.getVisibilityHash(config)
            };

            this.handleComponent = this.handleComponent.bind(this);
        }

        _getBlock(id) {
            if (!contentBlocks) {
                return null;
            }
            let temp;
            for (let i = 0; i < contentBlocks.length; i++) {
                temp = contentBlocks[i];
                if (temp.id != id) {
                    continue;
                }
                return temp;
            }
            const layoutBlocks = LayoutBlocks.get();
            for (let i = 0; i < layoutBlocks.length; i++) {
                temp = layoutBlocks[i];
                if (temp.id != id) {
                    continue;
                }
                return temp;
            }
            return null;
        }

        _getConfig(props) {
            return props.contentConfig || props.config;
        }

        shouldComponentUpdate(nextProps, nextState) {
            if (nextProps.builder) {
                return true;
            }
            const config = this._getConfig(nextProps);
            if (this.props.config && config && this.props.config.id != config.id) {
                return true;
            }
            const hash = nextProps.visibilityHash || Utilities.Config.getVisibilityHash(config);
            if (hash != nextState.hash) {
                this.setState({
                    hash
                });
                return true;
            }
            return false;
        }

        // componentDidUpdate() {
        //     const config = this._getConfig(this.props);
        //     if (this.state.config && config && this.state.config.id != config.id) {
        //         this.setState({
        //             config
        //         });
        //     }
        // }

        handleComponent(d) {
            if (!this.props.config) {
                return null;
            }
            const block = this._getBlock(d.type && d.type.value);
            if (!block || !block.component) {
                return null;
            }
            const BlockComponent = block.component;
            let blockProps = {};
            if (this.props.onBlockProps) {
                blockProps = this.props.onBlockProps(d);
            }
            let blockExtras = {}
            if (blockExtrasHandler) {
                blockExtras = blockExtrasHandler(this.props, d) || {};
            }
            let className = blockProps.className;
            if (this.props.builder) {
                if (className) {
                    className += ' draggable';
                } else {
                    className = 'draggable';
                }
                if (blockProps.active) {
                    className += ' draggable-active';
                }
            }
            return (
                <BlockComponent
                    {...this.props}
                    key={d.Id || d.id}
                    className={className}
                    collateralConfig={this.props.config}
                    config={blockProps.config || blockProps.block || d}
                    data={this.props.data || {}}
                    forceVisibility={this.props.forceVisibility}
                    onClick={this.props.onBlockClick}
                    onComponent={this.handleComponent}
                    onDragStart={this.props.onBlockDragStart}
                    {...blockExtras} />
            );
        }

        render() {
            const config = this._getConfig(this.props) || {};
            let content;
            if (config.Config && config.Config.blocks) {
                content = []
                config.Config.blocks.forEach((d) => {
                    const BlockComponent = this.handleComponent(d);
                    if (!BlockComponent) {
                        return;
                    }
                    content.push(BlockComponent);
                });
            }
            if (this.props.editor) {
                // Add a hidden element above the content so blocks can be dragged to the top (moving to first place)
                let className = 'editable editor';
                if (this.props.dragging) {
                    className += ' dragging';
                }
                content = (
                    <div id={this.props.id}
                        className={className}
                        onDragEnter={this.props.onDragEnter}
                        onDragOver={(e) => { if (e) { e.preventDefault() } }}
                        onDrop={this.props.onDrop}>
                        <div id="top-hidden-exit" className="hidden draggable" onDragEnter={this.props.onDragEnter} />
                        <div id="top-hidden-enter" className="hidden draggable" onDragEnter={this.props.onDragEnter} />
                        {content}
                        <div id="bottom-hidden-enter" className="bottom-hidden hidden draggable" onDragEnter={this.props.onDragEnter} />
                        <div id="bottom-hidden-exit" className="bottom-hidden hidden draggable" onDragEnter={this.props.onDragEnter} />
                    </div>
                );
            }
            return (
                <WrappedComponent {...this.props} collateralConfig={this.props.config} config={config} content={content}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

export { withBlockRendering };